import { twMerge, type ClassNameValue } from 'tailwind-merge';

/** Joins class names; later Tailwind utilities override earlier conflicting ones. */
export function cn(...classes: ClassNameValue[]): string {
  return twMerge(...classes);
}
